<glxy-alert
  *ngIf="notificationWarningView$ | async"
  type="info"
  [showAction]="true"
  actionTitle="{{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS' | translate }}"
  (actionClick)="turnOnNotifications()"
  [showClose]="true"
  (close)="onClose()"
  [size]="viewMode ? 'large' : 'small'"
  [stackedView]="viewMode === false"
>
  <strong>{{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS' | translate }}</strong>
  {{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS_DETAILS' | translate }}
  <strong>{{ 'INBOX.WARNING.NOTIFICATION_SETTINGS' | translate }}</strong>
</glxy-alert>
<nav
  dynamicHeight
  mat-tab-nav-bar
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  animationDuration="0ms"
  [tabPanel]="tabPanel"
>
  <a mat-tab-link [active]="(selectedViewId$ | async) === allViewId" (click)="showView(allViewId)">
    {{ allViewId | viewName | translate }}
  </a>
  <a
    *ngFor="let view of views$ | async"
    mat-tab-link
    [active]="(selectedViewId$ | async) === view.viewId"
    (click)="showView(view.viewId)"
  >
    <mat-icon>star</mat-icon>
    {{ view.viewId | viewName | translate }}&nbsp;
    <glxy-badge size="small" color="red-solid">
      {{ view.viewId | unreadConversationsCount | async }}
    </glxy-badge>
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <!-- we don't need this tab panel, but mat-tab-nav-bar requires it, so
  rendering an empty one with 0 height -->
</mat-tab-nav-panel>
